
import React, {Component} from 'react';
import RowElement from './RowElement';

class Column extends Component {
    state = {
        isRowFullWidth: false,
        isDraggedOver: false
    };

    ondrageOver = () => {
        this.setState({isDraggedOver: true}, () => {

            this.props.addGhostElementOnDragOver("COLUMN", {
                                    columnId: this.props.columnId
                                })
        })
    }
    onDragLeave = () => {
         this.props.removeGhostElementOnDragLeave("COLUMN", {
                        columnId: this.props.columnId
                    })
    }
    render() {
        const { partialWidth, partialMargin } = this.props.partials;
        const {width, margin} = this.props.columnStyle;
        return (
            <div
                onClick={() =>
                    this.setState({
                        isRowFullWidth: !this.state.isRowFullWidth
                    })
                }
                onDragOver={() => !this.state.isDraggedOver && this.ondrageOver()}
                onDragLeave={() => this.state.isDraggedOver && this.onDragLeave()
                   
                }
                style={{
                    width: `${width}%`,
                    minHeight: 50,
                    // background: "blue",
                    marginLeft: `${margin}%`,
                    transition: "all 0.5s",
                    background: "purple",
                    zIndex: 20
                }}
            >
                {this.props.elementsInColumn.map((element) => {
                    const { elementId, elementStyle } = element;
                    return (
                        <RowElement
                            key={elementId}
                            elementId={elementId}
                            element={element}
                            elementStyle={elementStyle}
                            addGhostElementOnDragOver={
                                this.props.addGhostElementOnDragOver
                                // console.log(object);
                            }
                            removeGhostElementOnDragLeave={
                                this.props.removeGhostElementOnDragLeave
                            }
                        />
                    );
                })}
            </div>
        );
    }
}
export default Column;